import React from "react";
import occLogo from "assets/images/occ-logo.png";
import { Spinner } from "common/components/Spinner";
import { useAppSelector, useAppTracking } from "common/hooks/storeHooks";
import { formErrors } from "common/selectors/rsfForm.selectors";
import { Button } from "common/components/Button";
import { CustomLink } from "common/components/CustomLink";

export interface Auth0LoginProps {
  loading?: boolean;
}

export const Auth0Login: React.FC<Auth0LoginProps> = ({ loading }) => {
  const error = useAppSelector((state) => formErrors(state, { path: ["auth0Login"] })?.get("login"));
  const dvhSupported = CSS.supports("(height: 100dvh)");
  const { Track } = useAppTracking({ category: "User" });

  return (
    <Track>
      <div className={`w-screen ${dvhSupported ? "h-[100dvh]" : "h-screen"} flex justify-center items-center`}>
        <div className="flex flex-col items-center space-y-xl">
          <img src={occLogo} alt={"OCC Logo"} />

          <Spinner loadingSelector={() => Boolean(loading)} />

          {error && (
            <div className="space-flex flex-col items-center space-y-md">
              <div>
                <div className="text-red-600 text-center">{error}</div>
              </div>
              <CustomLink href="/sso/login" className="flex justify-center">
                <Button analyticsAction="retry">Try Again</Button>
              </CustomLink>
            </div>
          )}
        </div>
      </div>
    </Track>
  );
};
